<div class="notification-dialog" *ngIf="data?.notificaciones">
  <div class="close-container"(click)="cerrar()">
    <span translate="no" translate="no" class="material-symbols-outlined close-btn">
      close
    </span>
  </div>


  <h2 class="dialog-title mt-4">Mis Notificaciones</h2>

  <div class="notifications-container" *ngIf="data.notificaciones.length > 0; else noNotifs">
    <div *ngFor="let notif of data.notificaciones" class="notification-card" [ngClass]="notif.tipo">
      <p>{{ notif.mensaje }}</p>

      <button *ngIf="notif.boton" mat-raised-button class="action-btn" (click)="ejecutarAccion(notif.boton)">
        {{ notif.boton.texto }}
      </button>
    </div>
  </div>

  <ng-template #noNotifs>
    <p class="no-notifications">No tienes notificaciones pendientes 🎉</p>
  </ng-template>
</div>